export default __webpack_public_path__ + "static/media/text analyze.7ef67ba2.jpg";